import React from 'react';
import BookingConfirmation from './steps/BookingConfirmation';

/**
 * Test/Preview page for Booking Confirmation
 * Access at: /booking-confirmation-test
 * 
 * This allows you to test the booking confirmation screen
 * including the new Apple Wallet and Google Wallet buttons
 * without going through a full booking.
 */
const BookingConfirmationPreview = () => {
  // Mock booking data for testing
  const mockBookingReference = `TEST-${Date.now()}`;
  
  const mockSelectedTickets = [
    {
      id: 1,
      title: 'Adult Ticket',
      quantity: 2,
      price: 15.00,
      total: 30.00
    },
    {
      id: 2,
      title: 'Child Ticket',
      quantity: 1,
      price: 8.00,
      total: 8.00
    }
  ];

  const mockSelectedDate = new Date('2025-12-25');
  
  const mockSelectedTimeSlot = {
    time: '2:00 PM',
    id: 'slot-1400'
  };

  const mockCustomerDetails = {
    firstName: 'John',
    lastName: 'Smith',
    email: 'test@example.com',
    phone: '07700 900123',
    addressLine1: '123 Test Street',
    city: 'Leicester',
    postcode: 'LE1 1AB'
  };

  const mockTotalAmount = 38.00; // £30 + £8
  const mockIsFamilySaver = true;

  // Mock booking summary with Family Saver discount data
  const mockBookingSummary = {
    totalAmount: 0.19,
    originalPrice: 38.00,
    finalPrice: 0.19,
    discounts: [
      {
        code: 'FamilySaver2',
        discountedAmount: 37.81
      }
    ],
    totalSavings: 37.81
  };

  // Mock Venpos basket with Family Saver discount applied
  const mockVenposBasket = {
    data: {
      totalPrice: 38.00,        // Original price
      finalPrice: 0.19,         // Price after 99.5% discount (Family Saver)
      totalDiscountedPrice: 37.81, // Amount saved
      discounts: [
        {
          code: 'FamilySaver2',            // FS code triggers "Family Saver" branding
          discountedAmount: 37.81,  // £37.81 saved
          discountType: 'Percentage',
          percentage: 99.5
        }
      ],
      groups: [
        {
          items: [
            {
              webSaleItemId: 1,
              name: 'Adult Ticket',
              discountedAmount: 0.13,  // Price after discount
              totalPrice: 30.00
            },
            {
              webSaleItemId: 2,
              name: 'Child Ticket',
              discountedAmount: 0.06,  // Price after discount
              totalPrice: 8.00
            }
          ]
        }
      ]
    }
  };

  return (
    <div style={{ paddingTop: '120px' }}>
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        border: 'none',
        padding: '1.5rem 2rem',
        margin: '1rem auto',
        maxWidth: '960px',
        borderRadius: '12px',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      }}>
        <h3 style={{ margin: '0 0 0.5rem 0', color: '#fff', fontSize: '1.25rem', fontWeight: '600' }}>
          TEST PREVIEW MODE - FAMILY SAVER
        </h3>
        <p style={{ margin: 0, fontSize: '0.95rem', color: 'rgba(255,255,255,0.95)', lineHeight: '1.6' }}>
          This is a test preview of the booking confirmation screen with the <strong>Family Saver discount</strong> applied.
          <br/>
          The booking reference and data are for testing purposes only.
          <br/>
          <strong>Test both Apple Wallet and Google Wallet buttons below!</strong>
        </p>
      </div>

      <BookingConfirmation
        bookingReference={mockBookingReference}
        selectedTickets={mockSelectedTickets}
        selectedDate={mockSelectedDate}
        selectedTimeSlot={mockSelectedTimeSlot}
        customerDetails={mockCustomerDetails}
        totalAmount={mockTotalAmount}
        venposBasket={mockVenposBasket}
        bookingSummary={mockBookingSummary}
        isFamilySaver={true}
      />
    </div>
  );
};

export default BookingConfirmationPreview;

